import { OnChangeParams, Option, Value } from 'baseui/select';
import CustomFormControl from 'components/elements/custom-form-control';
import Select from 'components/elements/master/select-input';
import * as React from 'react';

export interface ReportSelectInputProps {
  label?: string;
  placeholder?: string;
  onClose?: () => void;
  value?: string;
  onSelected?: (value?: string) => void;
  noMargin?: boolean;
  options?: Option[];
}

export default function ReportSelectInput(props: ReportSelectInputProps) {
  const {
    label = ' ',
    placeholder = ' ',
    onSelected,
    options = [],
    ...rest
  } = props;

  const [value, setValue] = React.useState<Value | undefined>(undefined);

  const onChange = React.useCallback(
    (param: OnChangeParams) => {
      const value = param?.value?.[0]?.id as string | undefined;
      setValue(param.value);
      props?.onSelected?.(value);
    },
    [props],
  );

  React.useEffect(() => {
    const value = options.find((option) => {
      return option.id === props.value;
    });
    setValue(value ? [value] : undefined);
  }, [options, props.options, props.value]);

  return (
    <CustomFormControl label={label} noMargin={props.noMargin}>
      <Select
        {...rest}
        type="select"
        placeholder={placeholder}
        value={value}
        filterOptions={null}
        options={options}
        onChange={onChange}
      />
    </CustomFormControl>
  );
}
